<template>
  <!-- 文章列表编辑组件 -->
  <div class="article-list-edit">
    <!-- :rules="rules"  -->
    <el-form :model="currentproperties" ref="formRef" label-width="120px">
      <el-form-item label="文章标题" prop="title">
        <el-input
          v-model="currentproperties.title"
          placeholder="请输入文章标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="文章内容" prop="content">
        <el-input
          v-model="currentproperties.content"
          placeholder="请输入文章内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="文章分类" prop="category">
        <el-select
          v-model="currentproperties.category"
          placeholder="请选择文章分类"
        >
          <el-option label="技术" value="技术"></el-option>
          <el-option label="生活" value="生活"></el-option>
          <el-option label="工作" value="工作"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章状态" prop="status">
        <el-radio-group v-model="currentproperties.status">
          <el-radio label="1">已发布</el-radio>
          <el-radio label="2">草稿</el-radio>
          <el-radio label="3">已下架</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
    name: 'ArticleListEdit',
  data() {
    return {
      currentproperties: {
        title: "",
        content: "",
        category: "",
        tags: [],
        status: "",
      },
    };
  },
};
</script>
<style scoped lang="scss">
.article-list-edit {
  border: 2px solid blue;
}
</style>
